export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/template/image/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/template/image/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/template/image/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.json({
              url: `/template/image/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/templateImages.js